type Filters = Record<string, any>;

const formatStartDate = (date: Date): string => {
  const startUTC = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0)
  );
  return startUTC.toISOString();
};

const formatEndDate = (date: Date): string => {
  const endUTC = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999)
  );
  return endUTC.toISOString();
};

const appendIfArray = (params: URLSearchParams, key: string, value?: any[]) => {
  if (Array.isArray(value) && value.length) params.append(key, value.join(","));
};

const appendIfString = (params: URLSearchParams, key: string, value?: unknown) => {
  if (typeof value === "string" && value.trim()) params.append(key, value);
};

const appendIfDefined = (
  params: URLSearchParams,
  key: string,
  value: unknown,
  predicate: (v: unknown) => boolean
) => {
  if (predicate(value)) params.append(key, String(value));
};

export const buildQueryStringFromFilters = (filters: Filters): string => {
  const params = new URLSearchParams();

  // dates
  const from = filters?.dateRange?.from;
  const to = filters?.dateRange?.to;

  if (from) params.append("startDate", formatStartDate(new Date(from)));
  if (to) params.append("endDate", formatEndDate(new Date(to)));

  // arrays (include + exclude + columns)
  const arrayKeys: Array<[string, string]> = [
    ["ots", "ots"],
    ["procedureIds", "procedureIds"],
    ["nurseIds", "nurseIds"],
    ["attendingSurgeonNames", "attendingSurgeonNames"],
    ["submittedBy", "submittedBy"],
    ["assignedAnesthesiologist", "assignedAnesthesiologist"],
    ["caseIds", "caseIds"],
    ["mrn", "patientMrn"],
    ["caseStartDelay", "delayCategories"],

    // exclude
    ["excludeOts", "excludeOts"],
    ["excludeProcedureIds", "excludeProcedureIds"],
    ["excludeNurseIds", "excludeNurseIds"],
    ["excludeAttendingSurgeonNames", "excludeAttendingSurgeonNames"],
    ["excludeAssignedAnesthesiologist", "excludeAssignedAnesthesiologist"],
    ["excludeDelayCategories", "excludeDelayCategories"],
    ["excludeCaseOrder", "excludeCaseOrder"],
    ["excludeCaseIds", "excludeCaseIds"],
    // columns
    ["selectedColumns", "selectedColumns"],
  ];

  arrayKeys.forEach(([filterKey, queryKey]) => {
    appendIfArray(params, queryKey, filters?.[filterKey]);
  });

  // strings
  appendIfString(params, "patientName", filters?.patientName);

  // enums / constrained values
  appendIfDefined(
    params,
    "caseOrder",
    filters?.caseOrder,
    (v) => v === "first" || v === "last"
  );

  appendIfDefined(
    params,
    "autoClosed",
    filters?.autoClosed,
    (v) => v === "true" || v === "false" || v === true || v === false
  );

  appendIfDefined(
    params,
    "inconsistentTimestamps",
    filters?.inconsistentTimestamps,
    (v) => v === "true" || v === "false" || v === true || v === false
  );

  appendIfDefined(
    params,
    "antibioticUsed",
    filters?.antibioticUsed,
    (v) => v === "true" || v === "false"
  );

  appendIfString(params, "excludeCaseOrder", filters?.excludeCaseOrder);
  appendIfString(params, "excludeCaseIds", filters?.excludeCaseIds?.join(","));


  return params.toString();
};
